// extracted by mini-css-extract-plugin
export default {"instruction":"iIKWY","error":"x4SU6","password":"ydz0m","logIn":"VeSx9","suggestion":"DbzWY","link":"jUXEw","margin":"PZjIm"};